import { render } from "./ReservationDocumentCard.vue?vue&type=template&id=ed1ed1d0&scoped=true"
import script from "./ReservationDocumentCard.vue?vue&type=script&lang=js"
export * from "./ReservationDocumentCard.vue?vue&type=script&lang=js"

import "./ReservationDocumentCard.vue?vue&type=style&index=0&id=ed1ed1d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed1ed1d0"]])

export default __exports__